import styled from '@emotion/styled'
import { Text, Title } from 'components/Typography'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SAboutTeam = styled.div`
  position: relative;
  margin-left: var(--p-content);
`

export const SRikardSection = styled.section`
  display: flex;
  align-items: center;
  margin-bottom: 7rem;

  @media ${BREAKPOINTS.LG.max} {
    align-items: flex-start;
    flex-direction: column;
  }

  @media ${BREAKPOINTS.MD.max} {
    margin-bottom: 4rem;
  }
`

export const SRikardImage = styled.div`
  position: relative;
  display: block;
  flex-shrink: 0;
  width: 50%;

  @media ${BREAKPOINTS.MD.max} {
    width: 100%;
  }

  &:before {
    content: '';
    border: 2px solid var(--c-blue100);
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    transform: translate(var(--p-content), var(--p-content));
  }

  @media ${BREAKPOINTS.MD.max} {
    &:before {
      display: none;
    }
  }
`

export const SRikardText = styled.div`
  margin-left: ${pxToRem(173)}rem;

  @media ${BREAKPOINTS.LG.max} {
    margin-left: 0;
    margin-top: 1.25rem;
  }
`

export const STeamGridWrapper = styled.div`
  position: relative;

  &:before {
    content: '';
    border: 2px solid var(--c-blue100);
    position: absolute;
    z-index: -1;
    top: calc(var(--p-content) * -1);
    left: calc(var(--p-content) * -1);
    right: var(--p-content);
    bottom: calc(-${pxToRem(45 + 27)}rem + var(--p-content));
  }

  @media ${BREAKPOINTS.MD.max} {
    &:before {
      display: none;
    }
  }
`

export const STeamGrid = styled.div`
  display: grid;
  grid-gap: 3rem 1.5rem;
  grid-template-columns: repeat(auto-fill, minmax(282px, 1fr));

  @media ${BREAKPOINTS.MD.max} {
    grid-gap: 1rem 0.5rem;
    grid-template-columns: repeat(2, 1fr);
  }
`

export const STeamGridFooterText = styled(Text)`
  width: 'max-content';
  margin-top: ${pxToRem(40)}rem;
`

export const SStorySmallHeader = styled(Title)`
  font-family: 'Lato';
`

export const SStoryHeader = styled(Title)`
  margin-top: 1.5rem;
`

export const SStoryParagraph = styled(Text)`
  margin-top: 1.5rem;
`

export const SStoryButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1.5rem;
`

export const SStorySection = styled.div`
  display: flex;
  gap: 32px;
`

export const SStorySignatureWrapper = styled.div`
  margin-top: 1.5rem;
`
